export default __webpack_public_path__ + "static/about-bdc29aa2467e083f03de62aef3a18cda.jpg";